import { Typography, Stack, Box } from '@mui/material';
import { useEffect, useState } from 'react';

const CountdownTimer = ({ targetDateTime, sx }) => {
  const calculateTimeRemaining = () => {
    const now = new Date();
    const [datePart, timePart] = targetDateTime?.split(' ') || [];
    const [day, month, year] = datePart?.split('-') || [];
    const [hours, minutes] = timePart?.split(':') || [];
    const target = new Date(year, month - 1, day, hours, minutes, 0); // Note: Months are 0-indexed in JavaScript Date object
    const timeRemaining = Math.max(0, target - now);
    const daysRemaining = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hoursRemaining = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutesRemaining = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const secondsRemaining = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    return {
      days: daysRemaining,
      hours: hoursRemaining,
      minutes: minutesRemaining,
      seconds: secondsRemaining,
    };
  };

  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining());
  const [timerExpired, setTimerExpired] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const remainingTime = calculateTimeRemaining();
      setTimeRemaining(remainingTime);

      if (
        isNaN(remainingTime.days) ||
        isNaN(remainingTime.hours) ||
        isNaN(remainingTime.minutes) ||
        isNaN(remainingTime.seconds)
      ) {
        setTimerExpired(true);
        clearInterval(intervalId);
      } else if (
        remainingTime.days === 0 &&
        remainingTime.hours === 0 &&
        remainingTime.minutes === 0 &&
        remainingTime.seconds === 0
      ) {
        setTimerExpired(true);
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [targetDateTime]);

  const formatTime = (value) => (value < 10 ? `0${value}` : value);

  return (
    <>
      {!timerExpired && (
        <Box sx={{ ...sx }}>
          <Stack direction="row" spacing={.5} justifyContent="center" alignItems="start">
            <Stack direction="column" alignItems="center">
              <Typography variant="h5" sx={{ background: 'hsl(233.56deg 31.71% 91.96%)', px: .5, borderRadius: '6px', fontWeight: 600 }}>{formatTime(timeRemaining.days)}</Typography>
              <Typography variant="caption">Days</Typography>
            </Stack>
            <Typography variant="h5">:</Typography>
            <Stack direction="column" alignItems="center">
              <Typography variant="h5" sx={{ background: 'hsl(233.56deg 31.71% 91.96%)', px: .5, borderRadius: '6px', fontWeight: 600 }}>{formatTime(timeRemaining.hours)}</Typography>
              <Typography variant="caption">Hrs</Typography>
            </Stack>
            <Typography variant="h5">:</Typography>
            <Stack direction="column" alignItems="center">
              <Typography variant="h5" sx={{ background: 'hsl(233.56deg 31.71% 91.96%)', px: .5, borderRadius: '6px', fontWeight: 600 }}>{formatTime(timeRemaining.minutes)}</Typography>
              <Typography variant="caption">Min</Typography>
            </Stack>
            <Typography variant="h5">:</Typography>
            <Stack direction="column" alignItems="center">
              <Typography variant="h5" sx={{ background: 'hsl(233.56deg 31.71% 91.96%)', px: .5, borderRadius: '6px', fontWeight: 600 }}>{formatTime(timeRemaining.seconds)}</Typography>
              <Typography variant="caption">Sec</Typography>
            </Stack>
          </Stack>
        </Box>
      )}
    </>
  );
};

export default CountdownTimer;
